import { AvailableMenuItems } from "../types/profileTypes";

export const noProfile: AvailableMenuItems = {
  availableitems: {
    agendar: false
  },
};

export const agendarProfile: AvailableMenuItems = {
  availableitems: {
    agendar: true,
  },
};


